/*
 * "Close every section and line of this entity's open card" — for a part of
 * the page that changed the whole record at once and wants it read back as
 * displays rather than open editors: the document suggestion panel after
 * Apply (task 38.03 §7). A window event, like NSERIE_ADVANCED, because the
 * sender sits in a side panel with no handle on the card's section state.
 *
 * Listened to by CardViewForm (its sections) and LineElement (lines), each
 * only for its own entity — not by a side panel of the same entity.
 */
export const CARD_COLLAPSE = 'uapp:card.collapseAll'

export const collapseCard = (entity) =>
    window.dispatchEvent(new CustomEvent(CARD_COLLAPSE, { detail: { entity } }))

// Subscribes `onCollapse` to collapses of `entity`; returns the unsubscribe.
export const onCardCollapse = (entity, onCollapse) => {
    const handler = (event) => { if (event.detail?.entity === entity) onCollapse() }
    window.addEventListener(CARD_COLLAPSE, handler)
    return () => window.removeEventListener(CARD_COLLAPSE, handler)
}
